<template>
  <div>
    <b-modal
      hide-footer
      no-close-on-esc
      :title-html="
        `<div class='d-flex align-items-center'><span class='lock'></span>&nbsp;<span>Authentication Required!</span></div>`
      "
      :ref="refId"
      :id="refId"
      header-class="managerAuthPop__header_class"
      :modal-class="
        isNovoClient
          ? 'managerAuthPop__modal_class managerAuthPop__modal_class--pin'
          : 'managerAuthPop__modal_class'
      "
      :content-class="
        isNovoClient ? 'managerAuthPop__content_class--pin' : ''
      "
      title-class="managerAuthPop__title_class"
      centered
      no-fade
      no-stacking
      no-enforce-focus
      no-close-on-backdrop
      @shown="onModalShown"
      @hidden="cancelAuth()"
    >
      <div v-if="isNovoClient" class="manager-auth-pin">
        <div class="manager-auth-pin__fields">
          <div class="manager-auth-pin__field">
            <label class="manager-auth-pin__label">User PIN</label>
            <div
              class="manager-auth-pin__box-wrap"
              :class="{ active: selectedType == 'userpin' }"
              @click="focusPinInput('userpin')"
            >
              <input
                @click="onClickInputType('userpin')"
                maxlength="4"
                inputmode="numeric"
                pattern="[0-9]*"
                v-model="userpin"
                type="password"
                ref="userpin"
                class="manager-auth-pin__native-input"
                @input="checkLength"
                @keyup.enter="authenticateLogin"
              />
              <span
                v-for="index in 4"
                :key="'user-pin-box-' + index"
                class="manager-auth-pin__digit-box"
                :class="{
                  filled: getPinDigit(userpin, index - 1),
                  focused: isPinDigitFocused('userpin', index - 1),
                }"
              >
                {{ getPinDigit(userpin, index - 1) ? "•" : "" }}
              </span>
            </div>
          </div>
          <div class="manager-auth-pin__field">
            <label class="manager-auth-pin__label">Password PIN</label>
            <div
              class="manager-auth-pin__box-wrap"
              :class="{ active: selectedType == 'passwordpin' }"
              @click="focusPinInput('passwordpin')"
            >
              <input
                @click="onClickInputType('passwordpin')"
                maxlength="4"
                inputmode="numeric"
                pattern="[0-9]*"
                v-model="passwordpin"
                type="password"
                ref="userpasswordpin"
                class="manager-auth-pin__native-input"
                @input="onPasswordPinInput"
                @keyup.enter="authenticateLogin"
              />
              <span
                v-for="index in 4"
                :key="'password-pin-box-' + index"
                class="manager-auth-pin__digit-box"
                :class="{
                  filled: getPinDigit(passwordpin, index - 1),
                  focused: isPinDigitFocused('passwordpin', index - 1),
                }"
              >
                {{ getPinDigit(passwordpin, index - 1) ? "•" : "" }}
              </span>
            </div>
          </div>
        </div>

        <div class="manager-auth-pin__pad">
          <button
            v-for="(value, index) in phone_value"
            :key="'pin-key-' + index"
            type="button"
            class="manager-auth-pin__key"
            :class="{
              'manager-auth-pin__key--muted':
                value.name == '' || index == phone_value.length - 1,
            }"
            @click.prevent.stop="
              index == phone_value.length - 1
                ? onSliceNumber()
                : value.name == ''
                ? clearPinInput()
                : onClickNumber(index)
            "
          >
            <span v-if="value.name != ''">{{ value.name }}</span>
            <span v-else>C</span>
          </button>
        </div>

        <div class="manager-auth-pin__actions">
          <button
            @click.prevent.stop="$bvModal.hide(refId)"
            class="btn btn-sm btn-outline-primary"
            style="color: var(--blue);"
          >
            Cancel
          </button>
          <button
            @click.prevent.stop="authenticateLogin"
            class="btn btn-sm btn-primary"
          >
            Authenticate
          </button>
        </div>
      </div>
      <div v-else class="row mx-0">
        <div class="col-12">
          <div class="col-lg-10 mx-auto align-self-center">
            <div class="">
              <div class="input-material">
                <input
                  type="text"
                  v-model="username"
                  v-on:keyup.enter="authenticateLogin"
                  name="username"
                  id="username"
                  required
                  placeholder="username"
                  @click="onClickInputHandler('username')"
                />
                <label>Username</label>
              </div>
              <div v-if="showKeyBoard">
                <VkeyboardFloat
                  :ID="'username'"
                  :onClickFun="
                    () => {
                      showUsernameVKeyboard = !showUsernameVKeyboard;
                    }
                  "
                />
                <Vkeyboard
                  :inputName="'username'"
                  :showOrHide="showUsernameVKeyboard"
                  :initialValue="username"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="authenticateLogin()"
                  @changeKeyboardInput="username = $event"
                  @onClickClose="
                    () => {
                      showUsernameVKeyboard = false;
                    }
                  "
                />
              </div>
              <p class="error_message"></p>
            </div>
            <div class="input-material">
              <input
                type="password"
                v-model="password"
                v-on:keyup.enter="authenticateLogin"
                name="password"
                id="password"
                required
                placeholder="password"
                @click="onClickInputHandler('password')"
              />
              <label>Password</label>
            </div>
            <div v-if="showKeyBoard">
              <VkeyboardFloat
                :ID="'password'"
                :onClickFun="
                  () => {
                    showPassVKeyboard = !showPassVKeyboard;
                  }
                "
              />
              <Vkeyboard
                :inputName="'password'"
                :initialValue="password"
                :showOrHide="showPassVKeyboard"
                :hideTypingInput="true"
                @onChangeEvent="() => {}"
                @onKeyEnter="authenticateLogin()"
                @changeKeyboardInput="password = $event"
                @onClickClose="
                  () => {
                    showPassVKeyboard = false;
                  }
                "
              />
            </div>
            <p class="error_message"></p>
            <div class="d-flex mt-1 justify-content-center">
              <button
                @click.prevent.stop="$bvModal.hide(refId)"
                class="btn btn-sm btn-outline-primary mr-5"
                style="color: var(--blue);"
              >
                Cancel
              </button>
              <button
                @click.prevent.stop="authenticateLogin"
                class="btn btn-sm btn-primary"
              >
                Authenticate
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import PosService from "@/services/PosService.js";
  import { BASEURL } from "@/config/index";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
  import ElectronAppService from "@/services/ElectronAppService";
  import { CLIENT_NAME } from "@/helper/Role";

  export default {
    props: {
      showKeyBoard: {
        type: Boolean,
        default: true,
      },
      refId: {
        type: String,
        default: "authManagerLoginPopup",
      },
      moduleName: {
        type: String,
        default: "default",
      },
      onCheckAuth: {
        type: Function,
        default: () => console.log("default function"),
      },
    },
    components: {
      Vkeyboard,
      VkeyboardFloat,
    },
    data() {
      return {
        loaderInstance: null,
        username: "",
        password: "",
        userpin: "",
        passwordpin: "",
        selectedType: "userpin",
        phone_value: [
          { name: "1" },
          { name: "2" },
          { name: "3" },
          { name: "4" },
          { name: "5" },
          { name: "6" },
          { name: "7" },
          { name: "8" },
          { name: "9" },
          { name: "" },
          { name: "0" },
          { name: "<-" },
        ],
        showVKeyboard: false,
        showPassVKeyboard: false,
        showUsernameVKeyboard: false,
        submitted: false,
      };
    },
    computed: {
      isNovoClient() {
        return CLIENT_NAME.NOVO == this.CLIENT_SETUP_NAME;
      },
    },
    mounted() {},
    methods: {
      onModalShown() {
        if (!this.isNovoClient) return;
        this.clearPinInput();
        this.$nextTick(() => {
          if (this.$refs["userpin"]) {
            this.$refs["userpin"].focus();
          }
        });
      },
      getPinDigit(value, index) {
        return String(value || "").charAt(index);
      },
      isPinDigitFocused(type, index) {
        if (this.selectedType != type) return false;
        const value = type == "userpin" ? this.userpin : this.passwordpin;
        const activeIndex = Math.min(String(value || "").length, 3);
        return index == activeIndex;
      },
      limitPin(type) {
        const pinValue = String(this[type] || "")
          .replace(/\D/g, "")
          .slice(0, 4);
        this[type] = pinValue;
        return pinValue;
      },
      focusPinInput(type) {
        this.onClickInputType(type);
        this.$nextTick(() => {
          const refName = type == "userpin" ? "userpin" : "userpasswordpin";
          if (this.$refs[refName]) {
            this.$refs[refName].focus();
          }
        });
      },
      onClickInputType(type) {
        this.selectedType = type;
      },
      maybeAutoSubmitPinLogin() {
        if (
          String(this.userpin || "").length >= 4 &&
          String(this.passwordpin || "").length >= 4
        ) {
          this.authenticateLogin();
        }
      },
      onPasswordPinInput() {
        this.limitPin("passwordpin");
        this.maybeAutoSubmitPinLogin();
      },
      checkLength() {
        let stringText = this.limitPin("userpin");
        if (
          stringText &&
          stringText.length > 3 &&
          this.$refs["userpasswordpin"]
        ) {
          this.onClickInputType("passwordpin");
          this.$refs["userpasswordpin"].focus();
        }
        this.maybeAutoSubmitPinLogin();
      },
      onClickNumber(number) {
        const keyValue = this.phone_value[number]
          ? this.phone_value[number].name
          : "";
        if (!keyValue || keyValue == "<-") return;
        if (this.selectedType == "userpin") {
          if (this.userpin && this.userpin.length >= 4) {
            this.onClickInputType("passwordpin");
            this.$refs["userpasswordpin"].focus();
          } else {
            this.userpin = String(this.userpin + keyValue).slice(0, 4);
            if (
              this.userpin &&
              this.userpin.length >= 4 &&
              this.$refs["userpasswordpin"]
            ) {
              this.onClickInputType("passwordpin");
              this.$refs["userpasswordpin"].focus();
            }
            this.maybeAutoSubmitPinLogin();
          }
        } else if (this.selectedType == "passwordpin") {
          if (this.passwordpin && this.passwordpin.length >= 4) return;
          this.passwordpin = String(this.passwordpin + keyValue).slice(0, 4);
          this.maybeAutoSubmitPinLogin();
        }
      },
      onSliceNumber() {
        if (this.selectedType == "userpin") {
          if (this.userpin.length > 0) {
            this.userpin = this.userpin.slice(0, -1);
          }
          if (this.userpin.length == 0) {
            this.userpin = "";
          }
        } else if (this.selectedType == "passwordpin") {
          if (this.passwordpin.length > 0) {
            this.passwordpin = this.passwordpin.slice(0, -1);
          }
          if (this.passwordpin.length == 0) {
            this.passwordpin = "";
          }
        }
      },
      clearPinInput() {
        this.userpin = "";
        this.passwordpin = "";
        this.selectedType = "userpin";
        this.$nextTick(() => {
          if (this.$refs["userpin"]) {
            this.$refs["userpin"].focus();
          }
        });
      },
      resetAuthFields() {
        this.username = "";
        this.password = "";
        this.userpin = "";
        this.passwordpin = "";
        this.selectedType = "userpin";
        this.showPassVKeyboard = false;
        this.showUsernameVKeyboard = false;
      },
      callOpenCashDrawer() {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          ElectronAppService.openCashDrawer()
            .then((response) => {
              console.log("RESPONSE", response);
            })
            .catch((err) => {
              console.log("Error:", err);
            });
        } else {
          console.log("CASH DRAWER OPEN ONLY FOR EXE");
        }
      },
      onClickInputHandler(event) {
        if (this.showUsernameVKeyboard && event == "password") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = true;
        } else if (this.showUsernameVKeyboard && event == "username") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = false;
        } else if (this.showPassVKeyboard && event == "username") {
          this.showUsernameVKeyboard = true;
          this.showPassVKeyboard = false;
        } else if (this.showPassVKeyboard && event == "password") {
          this.showUsernameVKeyboard = false;
          this.showPassVKeyboard = false;
        }
      },
      cancelAuth() {
        this.resetAuthFields();
        this.$emit("AuthValid", false);
        this.onCheckAuth({
          name: this.moduleName,
          valid: false,
          user_id: null,
        });
      },
      authenticateLogin() {
        this.submitted = true;

        const username = this.isNovoClient ? this.userpin : this.username;
        const password = this.isNovoClient ? this.passwordpin : this.password;

        if (
          !username ||
          !password ||
          String(username).trim() == "" ||
          String(password).trim() == ""
        ) {
          this.submitted = false;
          this.$toasted.show(
            this.isNovoClient
              ? "Please enter both PINs"
              : "Invalid username or password"
          );
          return;
        }

        this.showLoading();

        PosService.CheckCinemaManagerAuth({
          username,
          password,
        })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$emit("ManagerDetails", data.user_id);
              this.resetAuthFields();
              this.$emit("AuthValid", true);

              this.onCheckAuth({
                name: this.moduleName,
                valid: true,
                user_id: data.user_id,
              });

              this.sendAuditLogs({
                operation: this.AUDIT_OPERATION.MANAGER_AUTH,
                outcome: this.AUDIT_OUTCOME.SUCCESS,
                message: "Manager authorization approved",
                details: {
                  "For Action": this.moduleName,
                  "Approved By (Manager ID)": data.user_id,
                  "Manager Username": username,
                },
              });

              this.$refs[this.refId].hide();
              if (data.user_id) {
                let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
                let USERSHIFTDATA = JSON.parse(
                  localStorage.getItem("USER_SHIFT_DATA")
                );
                console.log(userInfo, "userInfo");
                if (this.moduleName == "openCashDraw") {
                  try {
                    this.sendAuditLogs({
                      action: `POS USER OPEN CASH DRAWER`,
                      page_name: "CASH DRAWER",
                      api_name: "",
                    });

                    let cinema_id = localStorage.getItem("cinema_id");
                    let userData = localStorage.getItem("USER_INFO") || "";

                    if (this.$socket) {
                      console.log(
                        "print_ticket from pos_login3123425454 open cash drawer"
                      );

                      if (
                        CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME ||
                        CLIENT_NAME.NOVO == this.CLIENT_SETUP_NAME
                      ) {
                        this.callOpenCashDrawer();
                      } else {
                        this.$socket.emit("on_print_ticket", {
                          cinema_id,
                          baseurl: BASEURL,
                          ttype: "empire-login-ticket",
                          openDrawer: "Y",
                          loginDateTime: userData,
                        });
                      }
                      console.log("print_ticket from pos_login");
                      PosService.CashDrawerLogs({
                        cinema_id: userInfo.cinema_id,
                        pos_logged_in_username: userInfo.username,
                        pos_logged_in_userId: userInfo.user_id,
                        auth_logged_in_userId: data.user_id,
                        role_id: userInfo.role_id,
                        role_name: userInfo.role_name,
                        hardware_obj: USERSHIFTDATA.hardware_obj,
                      });
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }
              }
            } else {
              this.$emit("ManagerDetails", null);
              this.$emit("AuthValid", false);
              this.onCheckAuth({
                name: this.moduleName,
                valid: false,
                user_id: null,
              });

              this.sendAuditLogs({
                operation: this.AUDIT_OPERATION.MANAGER_AUTH,
                outcome: this.AUDIT_OUTCOME.FAILED,
                message: data.message || "Manager authorization denied",
                details: {
                  "For Action": this.moduleName,
                  "Manager Username": username,
                },
              });

              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch((err) => {
            this.$emit("AuthValid", false);
            this.onCheckAuth({
              name: this.moduleName,
              valid: false,
              user_id: null,
            });

            this.sendAuditLogs({
              operation: this.AUDIT_OPERATION.MANAGER_AUTH,
              outcome: this.AUDIT_OUTCOME.FAILED,
              message: "Manager authorization request failed",
              details: {
                "For Action": this.moduleName,
                "Manager Username": username,
              },
            });
            console.log("Error:", err);
          })
          .finally(() => {
            this.hideLoading();
          });
      },
    },
  };
</script>
<style>
  .disbled-section {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .managerAuthPop__title_class {
    font-size: 12px !important;
  }

  .managerAuthPop__header_class {
    padding: 0.4rem 1rem !important;
  }

  .managerAuthPop__modal_class--pin .modal-dialog {
    max-width: 360px;
    width: calc(100% - 24px);
    margin: 1.75rem auto;
  }

  .managerAuthPop__content_class--pin {
    padding: 16px 20px 20px !important;
  }

  .manager-auth-pin {
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
  }

  .manager-auth-pin__fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }

  .manager-auth-pin__field {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 0;
  }

  .manager-auth-pin__label {
    display: block;
    width: 100%;
    margin-bottom: 8px;
    color: #596273;
    font-size: 11px;
    font-weight: 700;
    text-align: center;
  }

  .manager-auth-pin__box-wrap {
    position: relative;
    width: fit-content;
    height: 34px;
    display: grid;
    grid-template-columns: repeat(4, 28px);
    gap: 4px;
    margin: 0 auto;
    cursor: text;
  }

  .manager-auth-pin__native-input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    opacity: 0;
    cursor: text;
  }

  .manager-auth-pin__digit-box {
    width: 28px;
    height: 34px;
    border: 1px solid #d8dee8;
    border-radius: 7px;
    color: #20242b;
    font-size: 15px;
    font-weight: 750;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    transition: border-color 0.16s ease, box-shadow 0.16s ease,
      background 0.16s ease;
  }

  .manager-auth-pin__digit-box.focused {
    border-color: var(--blue);
    box-shadow: 0 0 0 2px rgba(18, 44, 106, 0.1);
  }

  .manager-auth-pin__digit-box.filled {
    background: #f8fafc;
  }

  .manager-auth-pin__pad {
    width: 100%;
    max-width: 260px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .manager-auth-pin__key {
    height: 42px;
    border: 1px solid #dfe4ec;
    border-radius: 11px;
    color: #2b313b;
    font-size: 14px;
    font-weight: 700;
    background: #ffffff;
    cursor: pointer;
    transition: border-color 0.14s ease, background 0.14s ease;
  }

  .manager-auth-pin__key:hover,
  .manager-auth-pin__key:focus {
    border-color: #b8c7dd;
    color: #1f2937;
    background: #f8fafc;
  }

  .manager-auth-pin__key--muted {
    color: #64748b;
    background: #f1f5f9;
  }

  .manager-auth-pin__actions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/AuthManagerLoginPopup.vue